import { render, staticRenderFns } from "./ProductLabelBulkAttachSectionDetail.vue?vue&type=template&id=0173de9d&"
import script from "./ProductLabelBulkAttachSectionDetail.vue?vue&type=script&lang=js&"
export * from "./ProductLabelBulkAttachSectionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports